import React from "react";
import AuthenticatedUserNavPanel from "../pages/Components/AuthenticatedUserNavPanel";
import MainContent from "./components/MainContent";

const AuthenticatedLayout = (props) => {
  return (
    <>
      <div className="vds-viewport" id="viewport">
        <AuthenticatedUserNavPanel>
        </AuthenticatedUserNavPanel>
        <MainContent>
          {props.children}
        </MainContent>
      </div>
    </>
  );
};

export default AuthenticatedLayout;
